import { createContext, useContext, useEffect, useRef, useState } from "react"
import { useAuth } from "../../auth/auth-provider/auth-provider";
import GetPriceMarkupChangeTypes from "../../api-layer/price-markup-change-type-api/GetPriceMarkupChangeTypes";

const PriceMarkupChangeTypeContext = createContext();


const PriceMarkupChangeTypeProvider = ({children}) => {
    const [priceMarkupChangeTypes, setPriceMarkupChangeTypes] = useState([]);
    const auth = useAuth()

     useEffect(() => {
       getPriceMarkupChangeTypes();
    }, [auth?.token,])

    const getPriceMarkupChangeTypes = () => {
        GetPriceMarkupChangeTypes().then(
            res => {
                setPriceMarkupChangeTypes(res.data);
            }
        ).catch(
            error => {
                setPriceMarkupChangeTypes([]);
            }
        );
    }

    return (
        <>
            <PriceMarkupChangeTypeContext.Provider
                value={{priceMarkupChangeTypes}}
            >
                {children}
            </PriceMarkupChangeTypeContext.Provider>
        </>

    ) ;
};

export default PriceMarkupChangeTypeProvider;

export const usePriceMarkupChangeTypes = () => {
    return useContext(PriceMarkupChangeTypeContext);
};
